// Client ID
// https://console.developers.google.com/

export const oAuthGoogleClientId =
  '380011789798-teilg48si673lnuakb2v0kfkk0qljh88.apps.googleusercontent.com';

export const oAuthGoogleClientIdDev =
  '380011789798-5n8p84ecedpjivjivi3ipl28ajjqe8q3.apps.googleusercontent.com';
